"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var typescript_authentication_general_1 = require("@gaf/typescript-authentication-general");
var GafOktaSession_1 = require("../models/GafOktaSession");
var GafStorageManagerMock = /** @class */ (function (_super) {
    __extends(GafStorageManagerMock, _super);
    function GafStorageManagerMock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(GafStorageManagerMock.prototype, "info", {
        get: function () {
            var value = new GafOktaSession_1.GafOktaSession();
            value.accessToken =
                'eyJhbGciOiJub25lIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL2p3dC1pZHAuZXhhbXBsZS5jb20iLCJzdWIiOiJtYWlsdG86bWlrZUBleGFtcGxlLmNvbSIsIm5iZiI6MTU1MDE0OTg4MiwiZXhwIjoxNTgxNjg1ODgyLCJpYXQiOjE1NTAxNDk4ODIsImp0aSI6ImlkMTIzNDU2IiwidHlwIjoiaHR0cHM6Ly9leGFtcGxlLmNvbS9yZWdpc3RlciJ9.'; //tslint:disable-line
            value.idToken =
                'eyJhbGciOiJub25lIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL2p3dC1pZHAuZXhhbXBsZS5jb20iLCJzdWIiOiJtYWlsdG86bWlrZUBleGFtcGxlLmNvbSIsIm5iZiI6MTU1MDE0OTg4MiwiZXhwIjoxNTgxNjg1ODgyLCJpYXQiOjE1NTAxNDk4ODIsImp0aSI6ImlkMTIzNDU2IiwidHlwIjoiaHR0cHM6Ly9leGFtcGxlLmNvbS9yZWdpc3RlciJ9.'; //tslint:disable-line
            value.profile = {
                email: 'a@b.com',
                firstName: 'first name',
                lastName: 'last name',
                nickname: 'nickname',
                name: 'Last, First',
            };
            return value;
        },
        set: function (value) {
            // do nothing
        },
        enumerable: true,
        configurable: true
    });
    GafStorageManagerMock.prototype.clear = function () {
        // do nothing
    };
    return GafStorageManagerMock;
}(typescript_authentication_general_1.GafStorageManager));
exports.GafStorageManagerMock = GafStorageManagerMock;
